export const getApiThumb = (api_thumb) => {
  return api_thumb ? `${process.env.REACT_APP_API_URL}/api/get-proxy-image?url=${encodeURIComponent(api_thumb)}` : null;
}